// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* Theme-aware palette (2026-08-13): the Setup lenses were hardcoded to
   dark-mode whites and vanished in light mode. Component vars, dark values
   under :host-context(.dark) — matches the app's :root.dark switching. */
:host {
  --lens-fg: rgba(0, 0, 0, 0.87);
  --lens-fg-soft: rgba(0, 0, 0, 0.55);
  --lens-fg-faint: rgba(0, 0, 0, 0.38);
  --lens-hover-bg: rgba(0, 0, 0, 0.05);
  --lens-line: rgba(0, 0, 0, 0.12);
  --lens-surface: rgba(0, 0, 0, 0.025);
}

:host-context(.dark) {
  --lens-fg: rgba(255, 255, 255, 0.92);
  --lens-fg-soft: rgba(255, 255, 255, 0.55);
  --lens-fg-faint: rgba(255, 255, 255, 0.38);
  --lens-hover-bg: rgba(255, 255, 255, 0.06);
  --lens-line: rgba(255, 255, 255, 0.12);
  --lens-surface: rgba(255, 255, 255, 0.03);
}

:host {
  display: block;
}

/* Section shell — mirrors the Setup tab's .setup-item look */
.setup-item {
  border: 1px solid var(--lens-line);
  border-radius: 12px;
  padding: 18px 20px;
  background: var(--lens-surface);
  transition: border-color 0.2s ease;
}
.setup-item.complete {
  border-color: rgba(102, 187, 106, 0.35);
  background: rgba(102, 187, 106, 0.04);
}

.setup-item-header {
  display: flex;
  align-items: center;
  gap: 12px;
}
.setup-item-header .status-icon {
  color: #66bb6a;
  flex: 0 0 auto;
}
.setup-item-header .setup-item-info {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-width: 0;
}
.setup-item-header .setup-item-title {
  font-weight: 600;
  font-size: 15px;
  color: var(--lens-fg);
}
.setup-item-header .setup-item-status {
  font-size: 12.5px;
  color: var(--lens-fg-soft);
}
.setup-item-header .setup-action-btn {
  flex: 0 0 auto;
}

/* Pool grid */
.cred-cards {
  margin-top: 16px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(210px, 1fr));
  gap: 12px;
}

.cred-card {
  border: 1px solid var(--lens-line);
  border-radius: 10px;
  padding: 12px 14px;
  background: var(--lens-surface);
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.cred-card.authed {
  border-color: rgba(102, 187, 106, 0.28);
}
.cred-card .cred-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}
.cred-card .cred-name {
  font-weight: 600;
  font-size: 14px;
  color: var(--lens-fg);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.cred-card .authed-icon {
  color: #66bb6a;
  font-size: 18px;
  height: 18px;
  width: 18px;
}
.cred-card .expired-icon {
  color: #ef9a9a;
  font-size: 18px;
  height: 18px;
  width: 18px;
}
.cred-card .cred-meta {
  display: flex;
  align-items: center;
  gap: 8px;
}
.cred-card .cred-vendor {
  font-size: 12px;
  color: var(--lens-fg-soft);
}
.cred-card .cred-foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 2px;
}
.cred-card .cred-status-text {
  font-size: 11.5px;
  color: #81c784;
}
.cred-card .cred-status-text.needs {
  color: var(--lens-fg-soft);
}
.cred-card .cred-remove {
  background: none;
  border: none;
  color: var(--lens-fg-faint);
  cursor: pointer;
  padding: 2px;
  display: inline-flex;
}
.cred-card .cred-remove:hover {
  color: #ef9a9a;
}
.cred-card .cred-remove mat-icon {
  font-size: 17px;
  height: 17px;
  width: 17px;
}
.cred-card .default-chip {
  font-size: 10.5px;
  color: var(--lens-fg-soft);
  border: 1px solid var(--lens-line);
  border-radius: 6px;
  padding: 1px 6px;
}

/* Mode badge — the billing legibility cue */
.mode-badge {
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.02em;
  padding: 2px 8px;
  border-radius: 999px;
  color: #90caf9;
  background: rgba(144, 202, 249, 0.12);
  border: 1px solid rgba(144, 202, 249, 0.25);
  white-space: nowrap;
}
.mode-badge.metered {
  color: #ffb74d;
  background: rgba(255, 183, 77, 0.12);
  border-color: rgba(255, 183, 77, 0.3);
}

.cred-empty {
  grid-column: 1/-1;
  font-size: 12.5px;
  color: var(--lens-fg-soft);
  padding: 8px 2px;
}

/* ── Create flow ── */
.cred-create {
  margin-top: 16px;
}

.create-head {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 14px;
}
.create-head .create-title {
  font-weight: 600;
  font-size: 14px;
  color: var(--lens-fg);
  flex: 1 1 auto;
  text-align: center;
}
.create-head .link-btn {
  background: none;
  border: none;
  color: var(--lens-fg-soft);
  cursor: pointer;
  font-size: 13px;
  display: inline-flex;
  align-items: center;
}
.create-head .link-btn:hover {
  color: #fff;
}
.create-head .link-btn.ghost {
  color: var(--lens-fg-soft);
}
.create-head .link-btn mat-icon {
  font-size: 18px;
  height: 18px;
  width: 18px;
}

.choice-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 12px;
}

.choice-card {
  border: 1px solid var(--lens-line);
  border-radius: 10px;
  padding: 16px;
  cursor: pointer;
  background: var(--lens-surface);
  transition: border-color 0.15s ease, background 0.15s ease, transform 0.05s ease;
}
.choice-card:hover:not(.disabled) {
  border-color: rgba(144, 202, 249, 0.5);
  background: rgba(144, 202, 249, 0.04);
}
.choice-card:active:not(.disabled) {
  transform: translateY(1px);
}
.choice-card.disabled {
  opacity: 0.5;
  cursor: default;
}
.choice-card .choice-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 6px;
}
.choice-card .choice-label {
  font-weight: 600;
  font-size: 15px;
  color: var(--lens-fg);
}
.choice-card .choice-blurb {
  font-size: 12.5px;
  color: var(--lens-fg-soft);
  line-height: 1.4;
}

/* The two on-ramp cards get a bit more presence */
.mode-cards .mode-card {
  padding: 20px 18px;
}
.mode-cards .mode-card:hover {
  border-color: rgba(144, 202, 249, 0.6);
}
.mode-cards .mode-card.metered:hover {
  border-color: rgba(255, 183, 77, 0.6);
  background: rgba(255, 183, 77, 0.04);
}

.coming-soon-chip {
  font-size: 10px;
  color: var(--lens-fg-soft);
  border: 1px solid var(--lens-line);
  border-radius: 6px;
  padding: 1px 6px;
}

/* Name step */
.name-step {
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-width: 460px;
}
.name-step .name-summary {
  font-size: 13px;
  color: var(--lens-fg-soft);
  margin: 0;
}
.name-step .name-summary strong {
  color: #90caf9;
}
.name-step .name-input {
  background: var(--lens-surface);
  border: 1px solid var(--lens-line);
  border-radius: 8px;
  padding: 10px 12px;
  color: #fff;
  font-size: 14px;
  outline: none;
}
.name-step .name-input:focus {
  border-color: rgba(144, 202, 249, 0.6);
}
.name-step .name-actions {
  display: flex;
  gap: 10px;
}
.name-step .name-hint {
  font-size: 12px;
  color: var(--lens-fg-faint);
  margin: 0;
}

/* ── Chunk A: clickable cards + inline credential detail ── */
.cred-card {
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease;
}
.cred-card.selected {
  border-color: rgba(144, 202, 249, 0.55);
  background: rgba(144, 202, 249, 0.05);
}
.cred-card .chevron {
  margin-left: auto;
  color: var(--lens-fg-faint);
  font-size: 18px;
  height: 18px;
  width: 18px;
  transition: transform 0.15s ease;
}
.cred-card .chevron.open {
  transform: rotate(180deg);
}

.cred-detail {
  margin-top: 12px;
  border: 1px solid rgba(144, 202, 249, 0.4);
  border-radius: 10px;
  background: var(--lens-surface);
  overflow: hidden;
}
.cred-detail .detail-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  border-bottom: 1px solid var(--lens-line);
}
.cred-detail .detail-title {
  font-weight: 600;
  font-size: 14px;
  color: var(--lens-fg);
}
.cred-detail .detail-vendor {
  font-weight: 400;
  font-size: 12.5px;
  color: var(--lens-fg-soft);
}
.cred-detail .detail-body {
  padding: 12px 14px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.cred-detail .detail-row {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 13px;
  color: var(--lens-fg);
}
.cred-detail .detail-row label {
  flex: 0 0 88px;
  color: var(--lens-fg-soft);
  font-size: 12px;
}
.cred-detail .detail-row.note {
  font-size: 12px;
  color: var(--lens-fg-soft);
}
.cred-detail .detail-row.actions {
  margin-top: 4px;
}
.cred-detail .detail-row .muted {
  color: var(--lens-fg-soft);
}
.cred-detail .detail-row .needs {
  color: #ffb74d;
}
.cred-detail .input-row {
  display: flex;
  gap: 8px;
  flex: 1 1 auto;
  align-items: center;
}
.cred-detail .detail-input {
  flex: 1 1 auto;
  background: var(--lens-surface);
  border: 1px solid var(--lens-line);
  border-radius: 8px;
  padding: 7px 10px;
  color: #fff;
  font-size: 13px;
  outline: none;
}
.cred-detail .detail-input:focus {
  border-color: rgba(144, 202, 249, 0.6);
}
.cred-detail .scopes {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.cred-detail .scope-chip {
  font-size: 11px;
  padding: 2px 8px;
  border-radius: 6px;
  color: var(--lens-fg);
  background: var(--lens-surface);
  border: 1px solid var(--lens-line);
  font-family: ui-monospace, "SF Mono", Menlo, monospace;
}
.cred-detail .link-btn {
  background: none;
  border: none;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  color: var(--lens-fg-soft);
}
.cred-detail .link-btn:hover {
  color: #fff;
}
.cred-detail .link-btn.ghost {
  color: var(--lens-fg-soft);
}
.cred-detail .link-btn.danger {
  color: #ef9a9a;
}
.cred-detail .link-btn.danger:hover {
  color: #ff8a8a;
}
.cred-detail .link-btn mat-icon {
  font-size: 17px;
  height: 17px;
  width: 17px;
}

/* ── #2b: OAuth sign-in panel — poached from backend-detail's auth flow ── */
.oauth-panel {
  display: flex;
  flex-direction: column;
  max-width: 520px;
}
.oauth-panel .auth-instructions {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0 0 10px 0;
  font-size: 13px;
  color: var(--lens-fg);
}
.oauth-panel .auth-instructions mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  color: #66bb6a;
  flex-shrink: 0;
}
.oauth-panel .oauth-link {
  font-size: 12.5px;
  color: var(--lens-fg-soft);
  margin: 0 0 6px 0;
}
.oauth-panel .oauth-link a {
  color: #90caf9;
  text-decoration: none;
}
.oauth-panel .oauth-link a:hover {
  text-decoration: underline;
}
.oauth-panel .auth-code-field {
  width: 100%;
  margin-top: 4px;
}
.oauth-panel .device-code {
  font-family: ui-monospace, "SF Mono", Menlo, monospace;
  font-size: 22px;
  font-weight: 600;
  letter-spacing: 0.18em;
  color: #fff;
  background: var(--lens-surface);
  border: 1px solid rgba(144, 202, 249, 0.35);
  border-radius: 8px;
  padding: 10px 14px;
  margin: 6px 0 10px 0;
  text-align: center;
  -webkit-user-select: all;
          user-select: all;
}
.oauth-panel .auth-error {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  margin-bottom: 8px;
  background: rgba(244, 67, 54, 0.12);
  border-radius: 8px;
  color: #ef9a9a;
  font-size: 12.5px;
}
.oauth-panel .auth-error mat-icon {
  flex-shrink: 0;
  font-size: 20px;
  width: 20px;
  height: 20px;
}
.oauth-panel .auth-actions {
  display: flex;
  gap: 10px;
  margin-top: 4px;
  align-items: center;
}
.oauth-panel .auth-actions button mat-spinner {
  margin-right: 8px;
}

.cred-scope-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin: 6px 0 2px;
  padding-top: 6px;
  border-top: 1px dashed rgba(128, 128, 128, 0.25);
}

.unscoped-hint {
  font-size: 11px;
  opacity: 0.55;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.scope-btn {
  font-size: 11px;
  background: transparent;
  border: 1px solid rgba(97, 175, 239, 0.55);
  border-radius: 999px;
  color: #61afef;
  cursor: pointer;
  padding: 2px 10px;
  white-space: nowrap;
  flex-shrink: 0;
}
.scope-btn:hover {
  background: rgba(97, 175, 239, 0.12);
}

.team-chip {
  font-size: 10px;
  border: 1px solid rgba(97, 175, 239, 0.5);
  border-radius: 999px;
  padding: 0 7px;
  color: #61afef;
}

.cred-account {
  font-size: 11px;
  opacity: 0.6;
  margin-top: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.cred-org {
  opacity: 0.8;
}

.slot-chip {
  border-color: rgba(97, 175, 239, 0.7) !important;
  color: #61afef !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/settings/credential-pool/credential-pool.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;;yEAAA;AAGA;EACE,8BAAA;EACA,mCAAA;EACA,oCAAA;EACA,oCAAA;EACA,gCAAA;EACA,oCAAA;AAEF;;AAAA;EACE,oCAAA;EACA,yCAAA;EACA,0CAAA;EACA,0CAAA;EACA,sCAAA;EACA,yCAAA;AAGF;;AAAA;EACE,cAAA;AAGF;;AAAA,6DAAA;AACA;EACE,kCAAA;EACA,mBAAA;EACA,kBAAA;EACA,+BAAA;EACA,kCAAA;AAGF;AADE;EACE,uCAAA;EACA,qCAAA;AAGJ;;AACA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAEF;AAAE;EACE,cAAA;EACA,cAAA;AAEJ;AAAE;EACE,aAAA;EACA,sBAAA;EACA,cAAA;EACA,YAAA;AAEJ;AAAE;EACE,gBAAA;EACA,eAAA;EACA,qBAAA;AAEJ;AAAE;EACE,iBAAA;EACA,0BAAA;AAEJ;AAAE;EACE,cAAA;AAEJ;;AAEA,cAAA;AACA;EACE,gBAAA;EACA,aAAA;EACA,4DAAA;EACA,SAAA;AACF;;AAEA;EACE,kCAAA;EACA,mBAAA;EACA,kBAAA;EACA,+BAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AACF;AACE;EACE,uCAAA;AACJ;AAEE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;AAAJ;AAEE;EACE,gBAAA;EACA,eAAA;EACA,qBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAAJ;AAEE;EAAe,cAAA;EAAgB,eAAA;EAAiB,YAAA;EAAc,WAAA;AAIhE;AAHE;EAAgB,cAAA;EAAgB,eAAA;EAAiB,YAAA;EAAc,WAAA;AASjE;AAPE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AASJ;AAPE;EACE,eAAA;EACA,0BAAA;AASJ;AAPE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;AASJ;AAPE;EACE,iBAAA;EACA,cAAA;AASJ;AARI;EAAU,0BAAA;AAWd;AATE;EACE,gBAAA;EACA,YAAA;EACA,2BAAA;EACA,eAAA;EACA,YAAA;EACA,oBAAA;AAWJ;AAVI;EAAU,cAAA;AAad;AAZI;EAAW,eAAA;EAAiB,YAAA;EAAc,WAAA;AAiB9C;AAfE;EACE,iBAAA;EACA,0BAAA;EACA,kCAAA;EACA,kBAAA;EACA,gBAAA;AAiBJ;;AAbA,4CAAA;AACA;EACE,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,gBAAA;EACA,oBAAA;EACA,cAAA;EACA,qCAAA;EACA,2CAAA;EACA,mBAAA;AAgBF;AAdE;EACE,cAAA;EACA,oCAAA;EACA,qCAAA;AAgBJ;;AAZA;EACE,iBAAA;EACA,iBAAA;EACA,0BAAA;EACA,gBAAA;AAeF;;AAZA,sBAAA;AACA;EACE,gBAAA;AAeF;;AAbA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AAgBF;AAdE;EACE,gBAAA;EACA,eAAA;EACA,qBAAA;EACA,cAAA;EACA,kBAAA;AAgBJ;AAdE;EACE,gBAAA;EACA,YAAA;EACA,0BAAA;EACA,eAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;AAgBJ;AAfI;EAAU,WAAA;AAkBd;AAjBI;EAAU,0BAAA;AAoBd;AAnBI;EAAW,eAAA;EAAiB,YAAA;EAAc,WAAA;AAwB9C;;AApBA;EACE,aAAA;EACA,2DAAA;EACA,SAAA;AAuBF;;AApBA;EACE,kCAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;EACA,+BAAA;EACA,gFAAA;AAuBF;AArBE;EACE,sCAAA;EACA,qCAAA;AAuBJ;AArBE;EAA0B,0BAAA;AAwB5B;AAvBE;EAAa,YAAA;EAAc,eAAA;AA2B7B;AAzBE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,kBAAA;AA2BJ;AAzBE;EACE,gBAAA;EACA,eAAA;EACA,qBAAA;AA2BJ;AAzBE;EACE,iBAAA;EACA,0BAAA;EACA,gBAAA;AA2BJ;;AAvBA,kDAAA;AACA;EACE,kBAAA;AA0BF;AAzBE;EAAU,sCAAA;AA4BZ;AA3BE;EAAkB,qCAAA;EAAuC,oCAAA;AA+B3D;;AA5BA;EACE,eAAA;EACA,0BAAA;EACA,kCAAA;EACA,kBAAA;EACA,gBAAA;AA+BF;;AA5BA,cAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;AA+BF;AA7BE;EACE,eAAA;EACA,0BAAA;EACA,SAAA;AA+BJ;AA9BI;EAAS,cAAA;AAiCb;AA/BE;EACE,+BAAA;EACA,kCAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;EACA,aAAA;AAiCJ;AAhCI;EAAU,sCAAA;AAmCd;AAjCE;EAAgB,aAAA;EAAe,SAAA;AAqCjC;AApCE;EACE,eAAA;EACA,2BAAA;EACA,SAAA;AAsCJ;;AAlCA,8DAAA;AACA;EACE,eAAA;EACA,0DAAA;AAqCF;AAnCE;EACE,uCAAA;EACA,qCAAA;AAqCJ;AAnCE;EACE,iBAAA;EACA,2BAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,gCAAA;AAqCJ;AApCI;EAAS,yBAAA;AAuCb;;AAnCA;EACE,gBAAA;EACA,0CAAA;EACA,mBAAA;EACA,+BAAA;EACA,gBAAA;AAsCF;AApCE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,yCAAA;AAsCJ;AApCE;EACE,gBAAA;EACA,eAAA;EACA,qBAAA;AAsCJ;AApCE;EACE,gBAAA;EACA,iBAAA;EACA,0BAAA;AAsCJ;AAnCE;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAqCJ;AAlCE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,qBAAA;AAoCJ;AAlCI;EACE,cAAA;EACA,0BAAA;EACA,eAAA;AAoCN;AAlCI;EACE,eAAA;EACA,0BAAA;AAoCN;AAlCI;EAAY,eAAA;AAqChB;AApCI;EAAS,0BAAA;AAuCb;AAtCI;EAAS,cAAA;AAyCb;AAtCE;EACE,aAAA;EACA,QAAA;EACA,cAAA;EACA,mBAAA;AAwCJ;AAtCE;EACE,cAAA;EACA,+BAAA;EACA,kCAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,eAAA;EACA,aAAA;AAwCJ;AAvCI;EAAU,sCAAA;AA0Cd;AAvCE;EAAU,aAAA;EAAe,eAAA;EAAiB,QAAA;AA4C5C;AA3CE;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,+BAAA;EACA,kCAAA;EACA,sDAAA;AA6CJ;AA1CE;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,0BAAA;AA4CJ;AA3CI;EAAU,WAAA;AA8Cd;AA7CI;EAAU,0BAAA;AAgDd;AA/CI;EAAW,cAAA;AAkDf;AAjDI;EAAiB,cAAA;AAoDrB;AAnDI;EAAW,eAAA;EAAiB,YAAA;EAAc,WAAA;AAwD9C;;AApDA,6EAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;AAuDF;AArDE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;EACA,qBAAA;AAuDJ;AAtDI;EAAW,eAAA;EAAiB,WAAA;EAAa,YAAA;EAAc,cAAA;EAAgB,cAAA;AA6D3E;AA3DE;EACE,iBAAA;EACA,0BAAA;EACA,iBAAA;AA6DJ;AA5DI;EAAI,cAAA;EAAgB,qBAAA;AAgExB;AAhE+C;EAAU,0BAAA;AAmEzD;AAjEE;EAAmB,WAAA;EAAa,eAAA;AAqElC;AApEE;EACE,sDAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,WAAA;EACA,+BAAA;EACA,2CAAA;EACA,kBAAA;EACA,kBAAA;EACA,oBAAA;EACA,kBAAA;EACA,wBAAA;UAAA,gBAAA;AAsEJ;AApEE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,kBAAA;EACA,mCAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;AAsEJ;AArEI;EAAW,cAAA;EAAgB,eAAA;EAAiB,WAAA;EAAa,YAAA;AA2E7D;AAzEE;EACE,aAAA;EACA,SAAA;EACA,eAAA;EACA,mBAAA;AA2EJ;AA1EI;EAAqB,iBAAA;AA6EzB;;AAzEA;EAAkB,aAAA;EAAe,mBAAA;EAAqB,8BAAA;EAAgC,QAAA;EAAU,iBAAA;EAAmB,gBAAA;EAAkB,gDAAA;AAmFrI;;AAlFA;EAAiB,eAAA;EAAiB,aAAA;EAAc,mBAAA;EAAqB,gBAAA;EAAkB,uBAAA;AA0FvF;;AAzFA;EAAa,eAAA;EAAiB,uBAAA;EAAyB,0CAAA;EAAwC,oBAAA;EAAsB,cAAA;EAAgB,eAAA;EAAiB,iBAAA;EAAmB,mBAAA;EAAqB,cAAA;AAqG9L;AApGE;EAAU,oCAAA;AAuGZ;;AAtGA;EAAa,eAAA;EAAiB,yCAAA;EAAuC,oBAAA;EAAsB,cAAA;EAAgB,cAAA;AA8G3G;;AA7GA;EAAgB,eAAA;EAAiB,YAAA;EAAa,eAAA;EAAiB,mBAAA;EAAqB,gBAAA;EAAkB,uBAAA;AAsHtG;;AArHA;EAAY,YAAA;AAyHZ;;AAvHA;EAAa,gDAAA;EAA8C,yBAAA;AA4H3D","sourcesContent":["/* Theme-aware palette (2026-08-13): the Setup lenses were hardcoded to\n   dark-mode whites and vanished in light mode. Component vars, dark values\n   under :host-context(.dark) — matches the app's :root.dark switching. */\n:host {\n  --lens-fg: rgba(0, 0, 0, 0.87);\n  --lens-fg-soft: rgba(0, 0, 0, 0.55);\n  --lens-fg-faint: rgba(0, 0, 0, 0.38);\n  --lens-hover-bg: rgba(0, 0, 0, 0.05);\n  --lens-line: rgba(0, 0, 0, 0.12);\n  --lens-surface: rgba(0, 0, 0, 0.025);\n}\n:host-context(.dark) {\n  --lens-fg: rgba(255, 255, 255, 0.92);\n  --lens-fg-soft: rgba(255, 255, 255, 0.55);\n  --lens-fg-faint: rgba(255, 255, 255, 0.38);\n  --lens-hover-bg: rgba(255, 255, 255, 0.06);\n  --lens-line: rgba(255, 255, 255, 0.12);\n  --lens-surface: rgba(255, 255, 255, 0.03);\n}\n\n:host {\n  display: block;\n}\n\n/* Section shell — mirrors the Setup tab's .setup-item look */\n.setup-item {\n  border: 1px solid var(--lens-line);\n  border-radius: 12px;\n  padding: 18px 20px;\n  background: var(--lens-surface);\n  transition: border-color 0.2s ease;\n\n  &.complete {\n    border-color: rgba(102, 187, 106, 0.35);\n    background: rgba(102, 187, 106, 0.04);\n  }\n}\n\n.setup-item-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n\n  .status-icon {\n    color: #66bb6a;\n    flex: 0 0 auto;\n  }\n  .setup-item-info {\n    display: flex;\n    flex-direction: column;\n    flex: 1 1 auto;\n    min-width: 0;\n  }\n  .setup-item-title {\n    font-weight: 600;\n    font-size: 15px;\n    color: var(--lens-fg);\n  }\n  .setup-item-status {\n    font-size: 12.5px;\n    color: var(--lens-fg-soft);\n  }\n  .setup-action-btn {\n    flex: 0 0 auto;\n  }\n}\n\n/* Pool grid */\n.cred-cards {\n  margin-top: 16px;\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(210px, 1fr));\n  gap: 12px;\n}\n\n.cred-card {\n  border: 1px solid var(--lens-line);\n  border-radius: 10px;\n  padding: 12px 14px;\n  background: var(--lens-surface);\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n\n  &.authed {\n    border-color: rgba(102, 187, 106, 0.28);\n  }\n\n  .cred-card-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 8px;\n  }\n  .cred-name {\n    font-weight: 600;\n    font-size: 14px;\n    color: var(--lens-fg);\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n  .authed-icon { color: #66bb6a; font-size: 18px; height: 18px; width: 18px; }\n  .expired-icon { color: #ef9a9a; font-size: 18px; height: 18px; width: 18px; }\n\n  .cred-meta {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n  }\n  .cred-vendor {\n    font-size: 12px;\n    color: var(--lens-fg-soft);\n  }\n  .cred-foot {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-top: 2px;\n  }\n  .cred-status-text {\n    font-size: 11.5px;\n    color: #81c784;\n    &.needs { color: var(--lens-fg-soft); }\n  }\n  .cred-remove {\n    background: none;\n    border: none;\n    color: var(--lens-fg-faint);\n    cursor: pointer;\n    padding: 2px;\n    display: inline-flex;\n    &:hover { color: #ef9a9a; }\n    mat-icon { font-size: 17px; height: 17px; width: 17px; }\n  }\n  .default-chip {\n    font-size: 10.5px;\n    color: var(--lens-fg-soft);\n    border: 1px solid var(--lens-line);\n    border-radius: 6px;\n    padding: 1px 6px;\n  }\n}\n\n/* Mode badge — the billing legibility cue */\n.mode-badge {\n  font-size: 10.5px;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  padding: 2px 8px;\n  border-radius: 999px;\n  color: #90caf9;\n  background: rgba(144, 202, 249, 0.12);\n  border: 1px solid rgba(144, 202, 249, 0.25);\n  white-space: nowrap;\n\n  &.metered {\n    color: #ffb74d;\n    background: rgba(255, 183, 77, 0.12);\n    border-color: rgba(255, 183, 77, 0.3);\n  }\n}\n\n.cred-empty {\n  grid-column: 1 / -1;\n  font-size: 12.5px;\n  color: var(--lens-fg-soft);\n  padding: 8px 2px;\n}\n\n/* ── Create flow ── */\n.cred-create {\n  margin-top: 16px;\n}\n.create-head {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 14px;\n\n  .create-title {\n    font-weight: 600;\n    font-size: 14px;\n    color: var(--lens-fg);\n    flex: 1 1 auto;\n    text-align: center;\n  }\n  .link-btn {\n    background: none;\n    border: none;\n    color: var(--lens-fg-soft);\n    cursor: pointer;\n    font-size: 13px;\n    display: inline-flex;\n    align-items: center;\n    &:hover { color: #fff; }\n    &.ghost { color: var(--lens-fg-soft); }\n    mat-icon { font-size: 18px; height: 18px; width: 18px; }\n  }\n}\n\n.choice-cards {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 12px;\n}\n\n.choice-card {\n  border: 1px solid var(--lens-line);\n  border-radius: 10px;\n  padding: 16px;\n  cursor: pointer;\n  background: var(--lens-surface);\n  transition: border-color 0.15s ease, background 0.15s ease, transform 0.05s ease;\n\n  &:hover:not(.disabled) {\n    border-color: rgba(144, 202, 249, 0.5);\n    background: rgba(144, 202, 249, 0.04);\n  }\n  &:active:not(.disabled) { transform: translateY(1px); }\n  &.disabled { opacity: 0.5; cursor: default; }\n\n  .choice-card-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 8px;\n    margin-bottom: 6px;\n  }\n  .choice-label {\n    font-weight: 600;\n    font-size: 15px;\n    color: var(--lens-fg);\n  }\n  .choice-blurb {\n    font-size: 12.5px;\n    color: var(--lens-fg-soft);\n    line-height: 1.4;\n  }\n}\n\n/* The two on-ramp cards get a bit more presence */\n.mode-cards .mode-card {\n  padding: 20px 18px;\n  &:hover { border-color: rgba(144, 202, 249, 0.6); }\n  &.metered:hover { border-color: rgba(255, 183, 77, 0.6); background: rgba(255, 183, 77, 0.04); }\n}\n\n.coming-soon-chip {\n  font-size: 10px;\n  color: var(--lens-fg-soft);\n  border: 1px solid var(--lens-line);\n  border-radius: 6px;\n  padding: 1px 6px;\n}\n\n/* Name step */\n.name-step {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  max-width: 460px;\n\n  .name-summary {\n    font-size: 13px;\n    color: var(--lens-fg-soft);\n    margin: 0;\n    strong { color: #90caf9; }\n  }\n  .name-input {\n    background: var(--lens-surface);\n    border: 1px solid var(--lens-line);\n    border-radius: 8px;\n    padding: 10px 12px;\n    color: #fff;\n    font-size: 14px;\n    outline: none;\n    &:focus { border-color: rgba(144, 202, 249, 0.6); }\n  }\n  .name-actions { display: flex; gap: 10px; }\n  .name-hint {\n    font-size: 12px;\n    color: var(--lens-fg-faint);\n    margin: 0;\n  }\n}\n\n/* ── Chunk A: clickable cards + inline credential detail ── */\n.cred-card {\n  cursor: pointer;\n  transition: border-color 0.15s ease, background 0.15s ease;\n\n  &.selected {\n    border-color: rgba(144, 202, 249, 0.55);\n    background: rgba(144, 202, 249, 0.05);\n  }\n  .chevron {\n    margin-left: auto;\n    color: var(--lens-fg-faint);\n    font-size: 18px;\n    height: 18px;\n    width: 18px;\n    transition: transform 0.15s ease;\n    &.open { transform: rotate(180deg); }\n  }\n}\n\n.cred-detail {\n  margin-top: 12px;\n  border: 1px solid rgba(144, 202, 249, 0.4);\n  border-radius: 10px;\n  background: var(--lens-surface);\n  overflow: hidden;\n\n  .detail-head {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 10px 14px;\n    border-bottom: 1px solid var(--lens-line);\n  }\n  .detail-title {\n    font-weight: 600;\n    font-size: 14px;\n    color: var(--lens-fg);\n  }\n  .detail-vendor {\n    font-weight: 400;\n    font-size: 12.5px;\n    color: var(--lens-fg-soft);\n  }\n\n  .detail-body {\n    padding: 12px 14px;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  .detail-row {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    font-size: 13px;\n    color: var(--lens-fg);\n\n    label {\n      flex: 0 0 88px;\n      color: var(--lens-fg-soft);\n      font-size: 12px;\n    }\n    &.note {\n      font-size: 12px;\n      color: var(--lens-fg-soft);\n    }\n    &.actions { margin-top: 4px; }\n    .muted { color: var(--lens-fg-soft); }\n    .needs { color: #ffb74d; }\n  }\n\n  .input-row {\n    display: flex;\n    gap: 8px;\n    flex: 1 1 auto;\n    align-items: center;\n  }\n  .detail-input {\n    flex: 1 1 auto;\n    background: var(--lens-surface);\n    border: 1px solid var(--lens-line);\n    border-radius: 8px;\n    padding: 7px 10px;\n    color: #fff;\n    font-size: 13px;\n    outline: none;\n    &:focus { border-color: rgba(144, 202, 249, 0.6); }\n  }\n\n  .scopes { display: flex; flex-wrap: wrap; gap: 6px; }\n  .scope-chip {\n    font-size: 11px;\n    padding: 2px 8px;\n    border-radius: 6px;\n    color: var(--lens-fg);\n    background: var(--lens-surface);\n    border: 1px solid var(--lens-line);\n    font-family: ui-monospace, \"SF Mono\", Menlo, monospace;\n  }\n\n  .link-btn {\n    background: none;\n    border: none;\n    cursor: pointer;\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    font-size: 13px;\n    color: var(--lens-fg-soft);\n    &:hover { color: #fff; }\n    &.ghost { color: var(--lens-fg-soft); }\n    &.danger { color: #ef9a9a; }\n    &.danger:hover { color: #ff8a8a; }\n    mat-icon { font-size: 17px; height: 17px; width: 17px; }\n  }\n}\n\n/* ── #2b: OAuth sign-in panel — poached from backend-detail's auth flow ── */\n.oauth-panel {\n  display: flex;\n  flex-direction: column;\n  max-width: 520px;\n\n  .auth-instructions {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    margin: 0 0 10px 0;\n    font-size: 13px;\n    color: var(--lens-fg);\n    mat-icon { font-size: 20px; width: 20px; height: 20px; color: #66bb6a; flex-shrink: 0; }\n  }\n  .oauth-link {\n    font-size: 12.5px;\n    color: var(--lens-fg-soft);\n    margin: 0 0 6px 0;\n    a { color: #90caf9; text-decoration: none; &:hover { text-decoration: underline; } }\n  }\n  .auth-code-field { width: 100%; margin-top: 4px; }\n  .device-code {\n    font-family: ui-monospace, \"SF Mono\", Menlo, monospace;\n    font-size: 22px;\n    font-weight: 600;\n    letter-spacing: 0.18em;\n    color: #fff;\n    background: var(--lens-surface);\n    border: 1px solid rgba(144, 202, 249, 0.35);\n    border-radius: 8px;\n    padding: 10px 14px;\n    margin: 6px 0 10px 0;\n    text-align: center;\n    user-select: all;\n  }\n  .auth-error {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 8px 12px;\n    margin-bottom: 8px;\n    background: rgba(244, 67, 54, 0.12);\n    border-radius: 8px;\n    color: #ef9a9a;\n    font-size: 12.5px;\n    mat-icon { flex-shrink: 0; font-size: 20px; width: 20px; height: 20px; }\n  }\n  .auth-actions {\n    display: flex;\n    gap: 10px;\n    margin-top: 4px;\n    align-items: center;\n    button mat-spinner { margin-right: 8px; }\n  }\n}\n\n.cred-scope-row { display: flex; align-items: center; justify-content: space-between; gap: 8px; margin: 6px 0 2px; padding-top: 6px; border-top: 1px dashed rgba(128,128,128,.25); }\n.unscoped-hint { font-size: 11px; opacity: .55; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }\n.scope-btn { font-size: 11px; background: transparent; border: 1px solid rgba(97,175,239,.55); border-radius: 999px; color: #61afef; cursor: pointer; padding: 2px 10px; white-space: nowrap; flex-shrink: 0;\n  &:hover { background: rgba(97,175,239,.12); } }\n.team-chip { font-size: 10px; border: 1px solid rgba(97,175,239,.5); border-radius: 999px; padding: 0 7px; color: #61afef; }\n.cred-account { font-size: 11px; opacity: .6; margin-top: 2px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }\n.cred-org { opacity: .8; }\n\n.slot-chip { border-color: rgba(97,175,239,.7) !important; color: #61afef !important; }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
